import { Actions, thunk } from 'easy-peasy';
import formatAllergy from '~/utils/formatAllergy';
import api from '~/services/api';
import { IClientDetailsActions, IClientDetailsStore, IThunkUpdateAllergy } from '../types';

const onUpdateAllergy: IThunkUpdateAllergy = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    const { requestInfo, requestPayload } = payload;

    const allergy = await api.clientDetails
      .updateAllergy(requestInfo, requestPayload)
      .then(r => formatAllergy(r.data));

    const allergies = localState.allergies.map(item => (item.id !== allergy.id ? item : allergy));

    setClientDetails({ allergies });
  },
);

export default onUpdateAllergy;
